import axios from 'axios'
import api from './api'
import Vue from 'vue';
let Base64 = require('js-base64').Base64;
import { Toast } from 'vant';
import qs from "qs";
Vue.use(Toast);
//创建axios实例对象
const envBaseUrl = process.env.VUE_APP_AXIOS_BASE_URL
// 2. 生产环境：拼接当前域名；开发环境：使用 /api 代理
let finalBaseURL = '';
if (process.env.NODE_ENV === 'production') {
  // 获取当前页面的 协议（http/https） + 域名+端口（如 xxx.com:8080）
  const currentDomain = window.location.protocol + '//' + window.location.host + '/api'
  // 生产环境：如果 envBaseUrl 有值则拼接，无值则直接使用当前域名
  finalBaseURL = currentDomain + (envBaseUrl || '')
} else {
  // 开发环境：直接使用 /api
  finalBaseURL = envBaseUrl
}
console.log(finalBaseURL,'finalBaseURL')
const  instance = axios.create({
    baseURL: finalBaseURL, //服务器地址
    // baseURL: window.location.protocol + '//' + window.location.host, //服务器地址
    timeout: 5000, //默认超时时长
    withCredentials: true, 
})

//请求拦截器
instance.interceptors.request.use(config=>{
    // 1. 初始化请求头（避免覆盖）
    config.headers = config.headers || {}

    // 2. 处理post/put请求的content-type（不覆盖已有请求头，只补充）
    if (['post', 'put'].includes(config.method?.toLowerCase())) {
      config.headers['content-type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
      console.log('config',config)
    }

    // 3. 处理token和lang（容错处理，避免报错）
    const token = localStorage.getItem('token')
    const lang = localStorage.getItem("lang")
    if (token) {
      // 扩展请求头，保留原有请求头（...展开语法）
      config.headers = {
        ...config.headers,
        'token': Base64.encode(token), // token Base64 编码
        'lang': lang ? lang.toLowerCase() : 'en' // lang 容错，默认日语
      }
    } else {
      // 无token时，也设置默认lang
      config.headers['lang'] = lang ? lang.toLowerCase() : 'en'
    }
    config.headers['accept-language'] = lang ? lang.toLowerCase() : 'en'
    // 4. 返回处理后的配置
    return config
},err=>{
    console.error('请求失败',err)
})

//响应拦截器
instance.interceptors.response.use(res=>{
    //此处对响应数据做处理
    if(res.data.msg === "鉴权错误"){
        // localStorage.clear();
        // this.$router.push({path:'/Login'})
    }
    return res //该返回对象会传到请求方法的响应对象中
},err=>{
    // 响应错误处理
    return Promise.reject(err);
})

//封装axios请求方法，参数为配置对象
//option = {method,url,params} method为请求方法，url为请求接口，params为请求参数
async function http(option = {}) {
    let result = null
    if(option.method === 'get' || option.method === 'delete'){
        //处理get、delete请求
        await instance[option.method](
            api[option.url],
            {params: option.data}
        ).then(res=>{
            result = res.data
            result.data = JSON.parse(Base64.decode(result.data));
        }).catch(err=>{
            result = err
        })
    }else if(option.method === 'post' || option.method === 'put'){
        //处理post、put请求
        await instance[option.method](
            api[option.url],
            qs.stringify(option.data)
        ).then(res=>{
            result = res.data;
            result.data = JSON.parse(Base64.decode(result.data));
        }).catch(err=>{
            result = err
        })
    }
    return result
}

export default http

